import { init, onShopifySectionLoad } from './utils/init';
import { initSwiper, initSwiperMobile } from './vendors/swiper';
import initHeader from './sections/header';
import initQuantitySelector from './components/quantity-selector';
import initFeaturedProducts from './sections/featured-products';

init((): void => {
  initSwiper();
  initSwiperMobile();
  initHeader();
  initQuantitySelector();
  initFeaturedProducts();
});

onShopifySectionLoad((): void => {
  initSwiper();
  initSwiperMobile();
  initFeaturedProducts();
});
